import React from 'react';
import styled from 'styled-components';
import { FiCheck } from 'react-icons/fi';
import theme from '../../../assets/css/theme';
import media from '../../../assets/css/media';
import { IconSetId } from '../../../modules/constants/iconSets';
import { ICON_SET_PREVIEWS } from './previewIcons';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;
  width: 100%;
  height: 30px;

  @media (max-width: ${media.mobile}) {
    gap: 10px;
    height: 20px;
  }
`;

// Fixed square box. The Handdrawn (Khushmeen) icons have non-square viewBoxes, so
// they letterbox inside it via the SVG default `preserveAspectRatio` and render a
// little smaller than the other sets — that is correct, do not stretch them.
const Glyph = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  color: ${theme.commonColors.main};

  svg {
    width: 100%;
    height: 100%;
  }

  /* Keeps the whole set beside the chevron in a phone-width pill. */
  @media (max-width: ${media.mobile}) {
    flex-basis: 18px;
    width: 18px;
    height: 18px;
  }
`;

const Label = styled.span`
  margin-left: 10px;
  font-size: ${theme.fontSizes.body};
  color: ${theme.commonColors.main};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Check = styled(FiCheck)`
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  margin-left: auto;
  color: ${theme.commonColors.main};
`;

interface IProps {
  setId: IconSetId;
  label: string;
  /** Only shown on menu rows — the closed control never renders a checkmark. */
  showCheck?: boolean;
}

export const IconSetPreview = ({ setId, label, showCheck = false }: IProps) => (
  <Row>
    {ICON_SET_PREVIEWS[setId].map((Icon, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Glyph key={`${setId}-${index}`}>
        <Icon aria-hidden />
      </Glyph>
    ))}
    <Label>{label}</Label>
    {showCheck && <Check aria-hidden />}
  </Row>
);

export default IconSetPreview;
